export default __webpack_public_path__ + "static/media/celcius-image.15a065ff.png";